<div [ngClass]="isDesktop ? 'min-h-[650px] max-h-[650px]' : 'h-[100vh]' " class="app-container mobile:w-full" #appContainer>
	<div class="content min-w-[{{feedWidth}}]" #mobileView>
		<div style="position: relative; min-height: {{maxFeedHeight}}; max-height: {{maxFeedHeight}}">
			<mat-toolbar color="primary" [ngStyle]="{ 'border-radius': isMobile ? 'none' : '24px 24px 0 0' }" style="position: absolute; height: 40px">
				<span fxFlex></span>
				<div fxLayout="column" fxLayoutAlign="center center">
					<small>{{ channel?.name }}</small>
				</div>
				<span fxFlex></span>
			</mat-toolbar>

			<div style="max-height: {{maxFeedHeight}}; overflow-y: scroll" class="channels-feed-content w-full pt-[40px]" [ngStyle]="{ 'border-radius': isMobile ? 'none' : scrollable ? '24px' : '24px' }" cdkScrollable #channelsFeedContent>
				<div cdkDropList class="notification-list" (cdkDropListDropped)="drop($event)" [cdkDropListAutoScroll]="true" [cdkDropListAutoScrollStep]="35">
					<div *ngFor="let notification of notifications" cdkDrag [cdkDragDisabled]="!isDraggable" [cdkDragData]="notification" #ngxContextMenu="ngxContextMenu" [contextMenu]="notificationMenu" [contextMenuSubject]="notification" [contextMenuValue]="notification">
						<div class="notification-placeholder" *cdkDragPlaceholder></div>
						<div cdkDragHandle class="flex justify-start bg-portals-theme-card-background" fxLayout="row" [ngStyle]="{ cursor: isDraggable ? 'pointer' : null }">
							<div cdkDragRootElement="channels-feed-content" class="w-full">
								<notification-preview
									[cdkDragData]="notification"
									[notification]="notification"
									[portalUser]="portalUser"
									[webAppView]="true"
									[videoHeight]="200"
									[status]="notification.state"
									[showStatus]="showAll"
									[color]="notification.state == 'PENDING' ? 'rgba(214, 162, 33, 0.2)' : notification.state == 'LIVE' ? 'rgba(103, 180, 28, 0.2)' : notification.state == 'DRAFT' ? 'rgba(51, 153, 255, 0.2)' : notification.state == 'EXPIRED' ? 'rgba(168, 15, 15, 0.2)' : 'rgba(157, 157, 157, 0.2)'"
								></notification-preview>
							</div>
						</div>
						<hr class="opacity-50" align="center">
					</div>
					<context-menu #contextMenu [menuClass]="menuClass" [disabled]="disabled" [dir]="dir" (open)="open($event)" (close)="close()">
						<ng-template contextMenuItem [subMenu]="changePosition">
							<label class="menu-group text-black">Position</label>
						</ng-template>

						<context-menu #changePosition>
							<ng-template contextMenuItem (execute)="handleMenu($event, 'top')">
								<label class="menu-label my-0 w-full flex flex-row text-black">
									<fa-icon class="basis-1/5 text-left" [icon]="'arrow-up-wide-short'"></fa-icon>
									<span>Move to top</span>
								</label>
							</ng-template>
							<ng-template contextMenuItem (execute)="handleMenu($event, 'bottom')">
								<label class="menu-label my-0 w-full flex flex-row text-black">
									<fa-icon class="basis-1/5 text-left" [icon]="'arrow-down-short-wide'"></fa-icon>
									<span>Move to bottom</span>
								</label>
							</ng-template>
							<ng-template contextMenuItem (execute)="handleMenu($event, 'up')">
								<label class="menu-label my-0 w-full flex flex-row text-black">
									<fa-icon class="basis-1/5 text-left" [icon]="'arrow-up'"></fa-icon>
									<span>Move up</span>
								</label>
							</ng-template>
							<ng-template contextMenuItem (execute)="handleMenu($event, 'down')">
								<label class="menu-label my-0 w-full flex flex-row text-black">
									<fa-icon class="basis-1/5 text-left" [icon]="'arrow-down'"></fa-icon>
									<span>Move down</span>
								</label>
							</ng-template>
						</context-menu>
						<context-menu #changeStatus>
							<ng-template contextMenuItem (execute)="handleMenu($event, 'live')">
								<label class="menu-label my-0 w-full flex flex-row text-black go-live">
									<fa-icon class="basis-1/5 text-left text-portals-theme-status-live" [icon]="'tower-broadcast'"></fa-icon>
									<span>Notify Live</span>
								</label>
							</ng-template>
							<ng-template contextMenuItem (execute)="handleMenu($event, 'delete')">
								<label class="menu-label my-0 w-full flex flex-row text-black delete-post">
									<fa-icon class="basis-1/5 text-left text-portals-theme-status-expired" [icon]="'trash-can'"></fa-icon>
									<span>Delete Post</span>
								</label>
							</ng-template>
						</context-menu>
					</context-menu>
				</div>
			</div>
		</div>
	</div>
</div>

<ng-template #shareDialog>
	<div class="modal-header" fxLayout="row">
		<img [alt]="channel.name" [src]="channel?.image?.url || 'assets/images/default.png'" class="channel-image" />
		<h3>{{ channel?.name }}</h3>
	</div>
	<ngx-qrcode [elementType]="elementType" [errorCorrectionLevel]="correctionLevel" cssClass="qrcode" value="{{ channel.share_url }}"></ngx-qrcode>
	<button (click)="shareConfirm()" [disableRipple]="true" cdkCopyToClipboard="{{ channel.share_url }}" mat-flat-button class="w-full rounded-none">SHARE</button>
</ng-template>
